module.exports = __webpack_public_path__ + "static/media/doctor_login_img.1c8064c4.svg";